export default function ArrowRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" viewBox="0 0 24 24" {...props}>
      <path d="M2.6 13h14.6l-5.3 5.3 1.4 1.4L21 12l-7.7-7.7-1.4 1.4 5.3 5.3H2.6v2z" fill="currentColor" />
    </svg>
  );
}
